import { registerEnum } from '@cbbt/lib-interface';
var Title;
(function (Title) {
    Title["Brigadier"] = "Brigadier";
    Title["Commander"] = "Commander";
    Title["Dame"] = "Dame";
    Title["Dr"] = "Dr";
    Title["Father"] = "Father";
    Title["Honourable"] = "Honourable";
    Title["Lady"] = "Lady";
    Title["Lord"] = "Lord";
    Title["Major"] = "Major";
    Title["Miss"] = "Miss";
    Title["Mr"] = "Mr";
    Title["Mrs"] = "Mrs";
    Title["Ms"] = "Ms";
    Title["Professor"] = "Professor";
    Title["Reverend"] = "Reverend";
    Title["Sergeant"] = "Sergeant";
    Title["Sir"] = "Sir";
})(Title || (Title = {}));
registerEnum(Title, 'Title');
export { Title };
//# sourceMappingURL=Title.js.map